//
//
//
//
//
//
//
//
//
//
//


import { storyDataToBlok } from '~/utils/storyblok'

export default {
  data () {
    const breadcrumbs = [
      { title: this.$t('legalHub.legalHub'), url: this.$url.articlesIndex() },
      { title: this.$t('legalHub.topic') },
    ]

    return {
      blok: null,
      breadcrumbs,
    }
  },

  async fetch () {
    // This is the front page story's path
    const storyData = await this.$sb.get(`cdn/stories${this.$url.articlesIndex()}`)
      .then(x => x.data)
    this.blok = storyDataToBlok(storyData)
  },
}

